import { Inject, Component, ViewChild, Input } from "@angular/core";
import { BaseImmutableValuePopupComponent } from "../shared/baseImmutableValuePopupComponent";
import { AbstractImmutableValueMessage } from "../../../shared/models/responses/messages/abstractImmutableValueMessage";
import { PopupIdentifiers } from "../../providers";

@Component({
  selector: 'read-only-popup',
  templateUrl: './readOnlyPopupComponent.html'
})
export class ReadOnlyPopupComponent extends BaseImmutableValuePopupComponent {

  ngOnInit() {
    this.popupIdentifier = PopupIdentifiers.ReadOnly;
    this.headerText = this.strings.ReadOnlyParameter;
    this.caption = this.strings.ValueIsLocked;
    this.description = this.strings.TheValueIsLockedDueToTheFollowingRules;
    this.icon = "lock";
  }
  
}